export const config = {
  YANDEX_METRICA_ID_COUNTER: 65161093,
};
